export class ValidationHelper {
    
    static ValidateEmail(email: string) {
        if (!email || email.length < 1) {
            return "Email cannot be empty";
        }
        else if (email.indexOf("@") < 0) {
            return "Invalid email address";
        }
        else if (email.indexOf(".") < 0) {
            return "Invalid email address";
        }
        else if (email.indexOf("@") > email.lastIndexOf(".")) {
            return "Invalid email address, the @ symbol must come before the last period";
        }
        else {
            return "";
        }
    }
}